import { z } from "zod";

const organisationAddressSchema = z.object({
  streetAddress: z.string().min(1, { message: "Street address is required" }),
  town: z.string().min(1, { message: "Town is required" }),
  postcode: z.string().min(1, { message: "Postcode is required" }),
  region: z.string().min(1, { message: "Region is required" }),
  country: z.string().min(1, { message: "Country is required" }),
});
type OrganisationAddressFormData = z.infer<typeof organisationAddressSchema>;

export { organisationAddressSchema };
export type { OrganisationAddressFormData };
